<template>
    <div>
        <label :for="inputID" class="lm-toggle-label">{{label}}</label>
        <div v-if="description !== ''" class="description-block">
            <p>{{description}}</p>
        </div>
        <div class="lm-toggle" role="radiogroup">
            <div role="radio"
                    class="lm-toggle-item"
                    v-for="(option, index) in options"
                    :key="index" :value="option.value"
                    :class="[{selected:value === option.value}]"
                    @click="change(option.value)"
            >
                {{ option.label }}
            </div>
        </div>
        <input v-if="input" :name="name" type="hidden" :value="value">
<!--        <select class="form-control" :id="inputID" @change="change">-->
<!--            <option v-for="(option, index) in options"-->
<!--                    :key="index" :value="option.value"-->
<!--                    :selected="value === option.value">-->
<!--                {{ option.label }}-->
<!--            </option>-->
<!--        </select>-->
    </div>
</template>

<script>
    export default {
        name: 'LoveMapToggle',
        props: {
            label: {
                type: String,
            },
            description: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
            },
            value: {},
            input: {},
            name: {},
        },
        computed: {
            inputID() {
                return `input-id-${this._uid}`;
            }
        },
        methods: {
            selectedOption(option) {
                // if (this.options.value) {
                //     // return option.value === this.mutableFlightSegment.country.code;
                // }
                // return false;
            },
            change(value) {
                this.$emit('input', value)
            }
        }
    }
</script>

<!--<style lang="scss">-->
<!--    .description-block {-->
<!--        text-align: left;-->

<!--        p {-->
<!--            font-style: italic;-->
<!--            vertical-align: baseline;-->
<!--            display: inline-block;-->
<!--            font-size: 10px;-->
<!--            color: #444444;-->
<!--        }-->
<!--    }-->

<!--    .lm-toggle-label{-->
<!--        margin-top: 0;-->
<!--    }-->

<!--    .lm-toggle{-->
<!--        margin-bottom: 0;-->

<!--        @supports (display: grid) {-->
<!--            display: grid;-->
<!--            grid-template-columns: minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr);-->
<!--            grid-template-areas: ". . . . .";-->

<!--            @media all and (max-width: 1600px) and (min-width: 1280px) {-->
<!--                grid-template-columns: minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr);-->
<!--                grid-template-areas: ". . . .";-->
<!--            }-->
<!--            @media all and (max-width: 1280px) {-->
<!--                grid-template-columns: minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr);-->
<!--                grid-template-areas: ". . . .";-->
<!--            }-->
<!--            @media all and (max-width: 1280px) and (min-width: 1024px) {-->
<!--                grid-template-columns: minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr);-->
<!--                grid-template-areas: ". . .";-->
<!--            }-->
<!--            @media all and (max-width: 1024px) and (min-width: 420px) {-->
<!--                grid-template-columns: minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr);-->
<!--                grid-template-areas: ". . . . .";-->
<!--                max-width: 500px;-->
<!--            }-->
<!--            @media all and (max-width: 420px) {-->
<!--                grid-template-columns: minmax(84px, 1fr) minmax(84px, 1fr) minmax(84px, 1fr);-->
<!--                grid-template-areas: ". . .";-->
<!--            }-->


<!--            grid-template-rows: 1fr;-->

<!--            grid-column-gap: 5px;-->
<!--            grid-row-gap: 5px;-->
<!--        }-->

<!--        &-item{-->
<!--            @supports (display: grid) {-->
<!--                /*display: block;*/-->
<!--                margin: 0!important;-->
<!--            }-->
<!--            &:first-child{-->
<!--                margin-left: 0;-->
<!--            }-->
<!--            &:last-child{-->
<!--                margin-right: 0;-->
<!--            }-->
<!--            @media all and (max-width: 520px) {-->
<!--                margin: 5px 5px;-->
<!--            }-->
<!--            @media all and (min-width: 1024px) and (max-width: 1740px) {-->
<!--                margin: 5px 5px;-->
<!--            }-->

<!--            user-select: none;-->
<!--            -ms-user-select: none;-->
<!--            -moz-user-select: none;-->
<!--            -webkit-user-select: none;-->

<!--            margin: 5px 15px;-->
<!--            padding: 10px 14px;-->
<!--            background: #d2d2d2;-->
<!--            display: inline-block;-->
<!--            font-size: 10px;-->
<!--            font-weight: bold;-->
<!--            min-width: 83px;-->
<!--            text-align: center;-->


<!--            &:hover{-->
<!--                cursor: ponter;-->
<!--                background: #696969;-->
<!--            }-->
<!--            &.selected{-->
<!--                background: #434343;-->
<!--                color: white;-->
<!--            }-->
<!--        }-->i
<!--    }-->
<!--    /*.lm-input {*/-->
<!--    /*width: 300px;*/-->
<!--    /*}*/-->
<!--</style>-->

<style lang="scss">
    @import '/wp-content/themes/shopkeeper-child/include/assets/css/LoveMapToggle.css';
</style>